module.exports = "/_next/static/images/blurred-17e54d9788ccb057a5065c56761ebe70.png";